/** Demo / screen-recording helpers. Enabled with ?demo=hangman|filler|dino|maze|opsTickles */

export const DEMO_GAMES = [
  "hangman",
  "filler",
  "flashcards",
  "dino",
  "maze",
  "opsTickles",
];

export const getDemoGameId = () => {
  if (typeof window === "undefined") return null;
  const value = new URLSearchParams(window.location.search).get("demo");
  return DEMO_GAMES.includes(value) ? value : null;
};

export const isDemoMode = () => Boolean(getDemoGameId());

export const publishDemoState = (payload) => {
  if (typeof window === "undefined" || !isDemoMode()) return;
  window.__ARCADE_DEMO__ = {
    ...(window.__ARCADE_DEMO__ || {}),
    ...payload,
  };
};
